'use client';

import {useEffect, useState} from 'react';
import LoadingScreen from '@/app/games/[gid]/_src/LoadingScreen';

export default function Error({
  reset = () => window.location.reload(),
  error,
  safeErrorMessage,
}: {
  safeErrorMessage?: string;
  error?: Error & {digest: string};
  reset?: () => void;
}) {
  const [shouldRenderReloadUI, setShouldRenderReloadUI] = useState(false);
  const errorMessage =
    safeErrorMessage || error?.message || 'An error occurred. Please try again later.';

  useEffect(() => {
    console.error('Error:', error || safeErrorMessage, `digest: ${error?.digest}`);

    let timeoutId: NodeJS.Timeout;
    const reloadAttempts = parseInt(sessionStorage.getItem('reloadAttempts') || '0', 10);

    if (reloadAttempts < 2) {
      timeoutId = setTimeout(() => {
        sessionStorage.setItem('reloadAttempts', String(reloadAttempts + 1));
        reset();
      }, 7000);
    } else {
      setShouldRenderReloadUI(true);
      sessionStorage.removeItem('reloadAttempts');
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [error, safeErrorMessage]);

  if (!shouldRenderReloadUI) {
    return (
      <div className='bg-gray-100 flex items-center justify-center h-screen'>
        <LoadingScreen />
      </div>
    );
  }

  return (
    <div className='bg-gray-100 flex items-center justify-center h-screen'>
      <div className='text-center'>
        <h2 className='mt-4 text-2xl font-semibold text-gray-800'>Error</h2>
        {shouldRenderReloadUI && (
          <>
            <p className='mt-2 text-gray-600 whitespace-break-spaces'>
              {errorMessage}&nbsp;{error?.digest}
            </p>
            <a
              href='/'
              className='mt-6 mr-2 inline-block bg-gradient-to-b from-[#1f8ed4] to-[#5ebffd] text-white px-6 py-2 rounded-lg shadow-md hover:bg-blue-600'
            >
              Go Back Home
            </a>

            <button
              onClick={() => reset()}
              className='mt-6 inline-block bg-gradient-to-b from-[#1f8ed4] to-[#5ebffd] text-white px-6 py-2 rounded-lg shadow-md hover:bg-blue-600'
            >
              Try again
            </button>
          </>
        )}
      </div>
    </div>
  );
}
